import { jsx as _jsx } from "react/jsx-runtime";
import { Button, buttonBaseClasses, useTheme } from '@mui/material';
import { useState } from 'react';
export const ConfirmButton = (props) => {
    const theme = useTheme();
    const { confirmMessage = 'Confirm?', onConfirm, children, ...rest } = props;
    const [willConfirm, setWillConfirm] = useState(false);
    const handleClick = () => {
        if (willConfirm) {
            props.onConfirm();
            setWillConfirm(false);
        }
        else {
            setWillConfirm(true);
        }
    };
    const confirmStyle = willConfirm
        ? (props.confirmStyle ?? {
            color: rest.color && rest.color !== 'inherit' ? theme.palette[rest.color].contrastText : theme.palette.error.contrastText,
            backgroundColor: rest.color && rest.color !== 'inherit' ? theme.palette[rest.color].main : theme.palette.error.main,
            borderColor: rest.color && rest.color !== 'inherit' ? theme.palette[rest.color].main : theme.palette.error.main,
        })
        : {};
    return (_jsx(Button, { ...rest, style: confirmStyle, sx: {
            ...rest.sx,
            [`& .${buttonBaseClasses.root}-label`]: {
                display: 'inline-grid',
                verticalAlign: 'top',
                alignItems: 'center',
                position: 'relative',
                '&::before': {
                    content: `'${children.toString().replaceAll("'", "\\'")}'`,
                    visibility: 'hidden',
                    whiteSpace: 'preserve nowrap',
                    width: 'auto',
                    gridRowStart: 1,
                    gridColumnStart: 1,
                },
                '&::after': {
                    content: `'${confirmMessage?.toString().replaceAll("'", "\\'")}'`,
                    visibility: 'hidden',
                    whiteSpace: 'preserve nowrap',
                    width: 'auto',
                    gridRowStart: 1,
                    gridColumnStart: 1,
                },
            },
        }, onClick: handleClick, onMouseLeave: () => {
            setWillConfirm(false);
        }, onBlur: () => {
            setWillConfirm(false);
        }, children: _jsx("span", { className: `${buttonBaseClasses.root}-label`, children: _jsx("span", { style: {
                    width: 'auto',
                    paddingInline: 0,
                    gridRowStart: 1,
                    gridColumnStart: 1,
                }, children: willConfirm && confirmMessage ? confirmMessage : children }) }) }));
};
